/**
 * CZNA-1474 — a part of a linked work's name (`100 $q $b $c $d` beside a linked `$a`), shown
 * and not edited. The value is the linked authority's, copied by the pick
 * (`utils/linkedHeadingCopy.ts`); "Odpojit" on `$a` drops the link and gives the part back
 * to the plain input.
 *
 * A list slot (a corporate work's `110 $b`) shows one row per value, as its editable form does.
 */
import React from 'react';
import { useIntl } from 'react-intl';
import { useWatch } from 'react-hook-form';
import { resolveLabel } from '../renderer/labelResolver';
import SubfieldInput from './SubfieldInput';
var LockedNamePart = function (_a) {
    var _b, _c, _d;
    var subfieldDef = _a.subfieldDef, pathPrefix = _a.pathPrefix, control = _a.control, inputId = _a.inputId;
    var intl = useIntl();
    var stored = useWatch({ control: control, name: "".concat(pathPrefix, ".").concat(subfieldDef.code) });
    var label = resolveLabel(subfieldDef, intl);
    var values = typeof stored === 'string'
        ? [stored]
        : ((_c = (_b = stored === null || stored === void 0 ? void 0 : stored.values) === null || _b === void 0 ? void 0 : _b.map(function (entry) { return entry.value; })) !== null && _c !== void 0 ? _c : [(_d = stored === null || stored === void 0 ? void 0 : stored.value) !== null && _d !== void 0 ? _d : '']);
    return (React.createElement("div", { "data-field-path": "".concat(pathPrefix, ".").concat(subfieldDef.code), "data-linked-name-part": subfieldDef.code }, (values.length ? values : ['']).map(function (value, idx) { return (React.createElement(SubfieldInput
    // eslint-disable-next-line react/no-array-index-key -- read-only rows, never reordered
    , { 
        // eslint-disable-next-line react/no-array-index-key -- read-only rows, never reordered
        key: idx, code: subfieldDef.code, inputId: idx === 0 ? inputId : "".concat(inputId, "-").concat(idx), label: label, value: value, required: subfieldDef.required, disabled: true })); })));
};
export default LockedNamePart;
